// import css
import Classes from "./style/Lonading.module.css";
// import imgs
import bedsImg from "../assets/image/services/beds.png";
import chairImg from "../assets/image/services/chair.png";
import computerTableImg from "../assets/image/services/computer-table.png";
import cupboardImg from "../assets/image/services/cupboard.png";
import cupboard1Img from "../assets/image/services/cupboard1.png";
import doorImg from "../assets/image/services/door.png";
import furnitureImg from "../assets/image/services/furniture.png";
import lampImg from "../assets/image/services/lamp.png";
import nightstandImg from "../assets/image/services/nightstand.png";
import rackImg from "../assets/image/services/rack.png";
import tableImg from "../assets/image/services/table.png";
import teaTableImg from "../assets/image/services/tea-table.png";
import wardrobeImg from "../assets/image/services/wardrobe.png";
import windowsImg from "../assets/image/services/windows.png";

export default function Service() {
  return (
    <section className={Classes.sectionServices}>
      <div className={Classes.service}>
        <h2 className={Classes.serviceHeading}>Service</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Libero
          voluptates voluptatem, ipsa quo animi at corrupti neque velit
          consequuntur explicabo minima commodi ad reiciendis a repellendus
          architecto consectetur odit aspernatur?
        </p>
      </div>
      <div
        className={`${Classes.container} ${Classes.grid} ${Classes.gridFourColum}`}
      >
        <div className={Classes.serviceBox}>
          <img src={tableImg} alt="furniture" srcSet="" />
          <h3>Table</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img src={chairImg} alt="furniture" srcSet="" />
          <h3>Chair</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img src={cupboardImg} alt="furniture" srcSet="" />
          <h3>Cupboard</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img src={furnitureImg} alt="furniture" srcSet="" />
          <h3>Locker</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img src={lampImg} alt="furniture" srcSet="" />
          <h3>Mini Drawer</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img src={nightstandImg} alt="furniture" srcSet="" />
          <h3>Showcase</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img src={computerTableImg} alt="furniture" srcSet="" />
          <h3>Computer Table</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img className="myasd" src={wardrobeImg} alt="furniture" srcSet="" />
          <h3>Large Showcase</h3>
        </div>

        <div className={Classes.serviceBox}>
          <img loading="lazy" src={cupboard1Img} alt="furniture" srcSet="" />
          <h3>Cupboard Table</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img loading="lazy" src={teaTableImg} alt="furniture" srcSet="" />
          <h3>Tea Table</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img loading="lazy" src={rackImg} alt="furniture" srcSet="" />
          <h3>Rack</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img loading="lazy" src={windowsImg} alt="furniture" srcSet="" />
          <h3>Window</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img loading="lazy" src={doorImg} alt="furniture" srcSet="" />
          <h3>Door</h3>
        </div>
        <div className={Classes.serviceBox}>
          <img loading="lazy" src={bedsImg} alt="furniture" />
          <h3 className="icone-heading">Bed</h3>
        </div>
      </div>
    </section>
  );
}
